import { render, staticRenderFns } from "./buyorder.vue?vue&type=template&id=e91fbd1c&scoped=true"
import script from "./buyorder.vue?vue&type=script&lang=js"
export * from "./buyorder.vue?vue&type=script&lang=js"
import style0 from "./buyorder.vue?vue&type=style&index=0&id=e91fbd1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e91fbd1c",
  null
  
)

export default component.exports